var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconEmoji = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0478 9.81186C10.0478 10.4735 9.61027 10.9645 9.06598 10.9645C8.53236 10.9645 8.10547 10.4735 8.10547 9.81186C8.10547 9.15018 8.53236 8.66992 9.06598 8.66992C9.61027 8.66992 10.0478 9.15018 10.0478 9.81186Z",
    fill: "#878793"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9283 9.81186C15.9283 10.4735 15.4907 10.9645 14.9465 10.9645C14.4128 10.9645 13.9753 10.4735 13.9753 9.81186C13.9753 9.15018 14.4128 8.66992 14.9465 8.66992C15.4907 8.66992 15.9283 9.15018 15.9283 9.81186Z",
    fill: "#878793"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5654 14.6571C15.5654 15.2868 14.146 16.8023 12.0009 16.8023C9.85574 16.8023 8.43631 15.2868 8.43631 14.6571C8.43631 14.5504 8.52169 14.5077 8.60707 14.5717C9.25808 15.1587 10.4214 15.7137 12.0009 15.7137C13.5804 15.7137 14.7437 15.1801 15.3947 14.5611C15.4694 14.497 15.5654 14.5504 15.5654 14.6571Z",
    fill: "#878793"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 12C22 17.4706 17.4706 22 12 22C6.53922 22 2 17.4706 2 12C2 6.53922 6.52941 2 11.9902 2C17.4608 2 22 6.53922 22 12ZM3.67647 12C3.67647 16.6275 7.37255 20.3333 12 20.3333C16.6275 20.3333 20.3431 16.6275 20.3333 12C20.3235 7.38235 16.6176 3.66667 11.9902 3.66667C7.36274 3.66667 3.67647 7.38235 3.67647 12Z",
    fill: "#878793"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconEmoji);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-emoji.467d6122a28850695986f86796239ee0.svg";